import React from "react";

export default class PageBuilderContentSelect extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    return(
      <div className="content-select-options-wrapper">
        {I18n.t('add')} <span className="content-select-option" onClick={() => this.props.onClick('text')} >{I18n.t('text')}</span>, <span className="content-select-option" onClick={() => this.props.onClick('chart')}>{I18n.t('chart')}</span> {I18n.t('or')} <span className="content-select-option" onClick={() => this.props.onClick('widget')} >{I18n.t('widget')}</span>
      </div>
    );
  };

};